<template>
  <div>
    <span class="subtitle-1">Competência</span>
    <v-row>
      <v-col md="6">
        <v-text-field
          label="Início"
          v-model="fields.invoice_date_between.value[0]"
          :rules="fields.invoice_date_between.rules"
          type="date"
          outlined dense
        ></v-text-field>
      </v-col>
      <v-col md="6">
        <v-text-field
          label="Fim"
          v-model="fields.invoice_date_between.value[1]"
          :rules="fields.invoice_date_between.rules"
          type="date"
          outlined dense
        ></v-text-field>
      </v-col>
    </v-row>
    <span class="subtitle-1">Vencimento</span>
    <v-row>
      <v-col md="6">
        <v-text-field
          label="Início"
          v-model="fields.due_date_between.value[0]"
          :rules="fields.due_date_between.rules"
          type="date"
          outlined dense
        ></v-text-field>
      </v-col>
      <v-col md="6">
        <v-text-field
          label="Fim"
          v-model="fields.due_date_between.value[1]"
          :rules="fields.due_date_between.rules"
          type="date"
          outlined dense
        ></v-text-field>
      </v-col>
    </v-row>
    <span class="subtitle-1">Pagamento</span>
    <v-row>
      <v-col md="6">
        <v-text-field
          label="Início"
          v-model="fields.payment_date_between.value[0]"
          :rules="fields.payment_date_between.rules"
          type="date"
          outlined dense
        ></v-text-field>
      </v-col>
      <v-col md="6">
        <v-text-field
          label="Fim"
          v-model="fields.payment_date_between.value[1]"
          :rules="fields.payment_date_between.rules"
          type="date"
          outlined dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-select
      label="Status"
      v-model="fields.invoice_status.value"
      :items="fields.invoice_status.options"
      item-text="description"
      item-value="value"
      type="text"
      multiple
      outlined dense
    ></v-select>
    <v-text-field
      label="Nome do Cliente"
      v-model="fields.customer_name.value"
      :rules="fields.customer_name.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-text-field
      label="Apelido do Cliente"
      v-model="fields.customer_nickname.value"
      :rules="fields.customer_nickname.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-text-field
      label="Telefone do Cliente"
      v-model="fields.customer_phone_number.value"
      :rules="fields.customer_phone_number.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-text-field
      label="CPF/CNPJ do Cliente"
      v-model="fields.customer_document.value"
      :rules="fields.customer_document.rules"
      type="text"
      outlined dense
    ></v-text-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'invoicesFilter',
  data: () => ({
    fields: {
      invoice_date_between: {
        value: [undefined, undefined],
        rules: []
      },
      due_date_between: {
        value: [undefined, undefined],
        rules: []
      },
      payment_date_between: {
        value: [undefined, undefined],
        rules: []
      },
      invoice_status: {
        value: [],
        options: [
          { description: 'Pago', value: 'paid' },
          { description: 'Atrasado', value: 'late' },
          { description: 'Em aberto', value: 'pending' },
          { description: 'Cancelado', value: 'canceled' },
          { description: 'Renegociado', value: 'renegotiated' },
          { description: 'Atualizando...', value: 'update' },
          { description: 'Cancelando...', value: 'cancel' },
          { description: 'Criando...', value: 'create' },
          { description: 'Sincronizando...', value: 'synchronize' }
        ],
        rules: []
      },
      customer_name: {
        value: '',
        rules: []
      },
      customer_nickname: {
        value: '',
        rules: []
      },
      customer_phone_number: {
        value: '',
        rules: []
      },
      customer_document: {
        value: '',
        rules: []
      },
      person_document: {
        value: '',
        rules: []
      }
    }
  }),
  computed: {
    ...mapGetters(['searchParams']),
    formParams () {
      return this.searchParams('invoices')
    }
  },
  watch: {
    fields: {
      handler (val) {
        this.$emit('datachange', this.fields)
      },
      deep: true
    },
    formParams: {
      handler (val) {
        for (let key in val) {
          if (this.fields[key] && this.fields[key] !== val[key]) this.fields[key].value = val[key]
        }
      },
      deep: true
    }
  },
  mounted () {
    for (let key in this.searchParams('invoices')) {
      if (this.fields[key] && this.fields[key] !== this.searchParams('invoices')[key]) this.fields[key].value = this.searchParams('invoices')[key]
    }
  }
}
</script>
